import { CompanyStatus } from '@/gen/inventory/v1/company_status_pb'

import { useIsIrqCompleted } from '@/pages/assessment/irq/use-is-irq-completed'
import { PreAssessmentStep } from '@/pages/assessment/pre-assessment-step-enum'

export const useUpcomingPreAssessmentStep = (
  companyId: string,
  engagementModeEnabled: boolean,
  companyStatus?: CompanyStatus,
): PreAssessmentStep | null => {
  const isIrqCompleted = useIsIrqCompleted(companyId, engagementModeEnabled)

  if (
    companyStatus === CompanyStatus.ASSESSMENT_REQUIRED ||
    companyStatus === CompanyStatus.APPROVED
  ) {
    if (isIrqCompleted) {
      return PreAssessmentStep.START
    }
  }

  if (!isIrqCompleted) {
    return PreAssessmentStep.IRQ
  }

  return null
}
